import { MarketingConsent } from '../classes/MarketingConsent';

export const INITIAL_FORM_STATE = {
  bookingMethod: '',
  showRegionFields: false,
  category: '',
  teamSize: '',
  otherSoftware: '',
  apiError: '',
  validationErrors: [],
  formSuccess: false,
  password: '',
  hasTerms: false,
  isMutating: false,
  timeZone: 62,
  countryCode: 'NZ',
  currency: 'NZD',
  email: '',
  firstName: '',
  lastName: '',
  businessName: '',
  phoneNumber: '',
  referralId: '',
  promoCode: '',
  gRecaptchaResponse: '',
  loginUrl: '',
  marketingConsent: MarketingConsent.Default,
  marketingConsentGranted: false,
  consentTemplateId: null,
};

export function formReducer(state, action) {
  switch (action.type) {
    case 'FIELD_CHANGE':
      return { ...state, [action.field]: action.value };
    case 'SET_FORM_STATE':
      return { ...state, ...action.payload };
    case 'SET_API_ERROR':
      return { ...state, apiError: action.value, formSuccess: false };
    case 'VALIDATION_FAILED':
      return { ...state, validationErrors: action.errors, formSuccess: false };
    case 'SET_FORM_SUCCESS':
      return { ...state, formSuccess: action.value };
    case 'SET_IS_MUTATING':
      return { ...state, isMutating: action.value };
    case 'RESET_FORM':
      return { ...INITIAL_FORM_STATE };
    default:
      return state;
  }
}
